import React, { Fragment } from "react";
import OthersBanner from "../../Components/Other/OthersBanner";
import { Helmet } from "react-helmet";

function Other() {
  const metaData = {
    title: "Other Downloads | Salaam Takaful Documents",
    description:
      "Download additional documents from Salaam Takaful including AML/CFT risk assessment and other resources.",
  };
  return (
    <Fragment>
      <Helmet>
        <title>{metaData.title}</title>
        <meta name="description" content={metaData.description} />
      </Helmet>
      <div className="container-fluid faderight ">
        <div className="row">
          <OthersBanner />
        </div>
      </div>
    </Fragment>
  );
}

export default Other;
